import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from '@teammood/shared/util/core';
import { endOfDay } from 'date-fns';
import { TeamForAdminService } from '../team/team-for-admin.service';
import { ActivatedRoute, Router } from "@angular/router";
import { filter, from, map, mergeMap } from "rxjs";

@Component({
    selector: 'set-yearly-subscription',
    templateUrl: './set-yearly-subscription.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SetYearlySubscriptionComponent implements OnInit {

  team_id: string;
  subscription: Subscription;
  
  constructor(
   private route: ActivatedRoute,
   private router: Router,
    private teamService: TeamForAdminService
  ) {
  }

  form: FormGroup = new FormGroup({
    created: new FormControl<string>('', [Validators.required]),
    start: new FormControl<string>('', [Validators.required]),
    end: new FormControl<string>('', [Validators.required]),
    capacity: new FormControl<number>(null, [Validators.required]),
    quadernoId: new FormControl<number>(null, [Validators.required]),
  });

  get created() {
    return this.form.get('created');
  }

  get start() {
    return this.form.get('start');
  }
  get end() {
    return this.form.get('end');
  }
  get capacity() {
    return this.form.get('capacity');
  }
  get quadernoId() {
    return this.form.get('quadernoId');
  }

  ngOnInit() {

    this.route.params
        .pipe(
            filter(params => !!params.teamId),
            mergeMap(params => {
              this.team_id = params.teamId;
              return from(this.teamService.get(this.team_id));
            }),
            map(team => {
              this.subscription = team.subscription;
              this.form.controls.created.setValue(this.subscription.created);
              this.form.controls.start.setValue(this.subscription.start);
              this.form.controls.end.setValue(this.subscription.end);
              this.form.controls.capacity.setValue(this.subscription.capacity);
              this.form.controls.quadernoId.setValue(this.subscription.quadernoId);
            })
        ).subscribe();
  }

  async submit() {
    const formValue = this.form.getRawValue();
    const updatedSubscription = {
      ...this.subscription,
      ...formValue,
      end: endOfDay(formValue.end)
    };

    await this.teamService.updateYearlySubscription(this.team_id, updatedSubscription);
    await this.router.navigate([`/admin/team/${this.team_id}`]);
  }
}

